// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  API_BASE_URL: 'https://app-service.cloudatler.com',
  CALENDLY_URL: 'https://calendly.com/visha-chauhan-reve/30min',
  EMAIL_PATTERN: '^(?!.{201})[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
